export const apiURL = 'https://api1.gradgoggles.com/';
